/* =====================================================================
   SLM ARTICLE - sommaire auto, filtres galerie, lightbox
   After Essentials x Save La Mermaid. Aucune dependance.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- 1. Sommaire genere depuis les H2 du corps ---------- */
  function buildToc() {
    var main = document.querySelector('[data-slm-main]');
    var list = document.querySelector('[data-slm-toc]');
    if (!main || !list) return;

    var headings = main.querySelectorAll('h2');
    if (!headings.length) {
      var aside = document.querySelector('[data-slm-aside]');
      if (aside) aside.style.display = 'none';
      return;
    }

    list.innerHTML = '';
    var links = [];
    Array.prototype.forEach.call(headings, function (h, i) {
      if (!h.id) h.id = 'slm-s' + (i + 1);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.dataset.tocLabel || h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, el: h });
    });

    var gal = document.querySelector('[data-slm-gallery]');
    if (gal) {
      if (!gal.id) gal.id = 'slm-galerie';
      var li2 = document.createElement('li');
      var a2 = document.createElement('a');
      a2.href = '#' + gal.id;
      a2.textContent = gal.dataset.tocLabel || 'Galerie photo';
      li2.appendChild(a2);
      list.appendChild(li2);
      links.push({ a: a2, el: gal });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY + 140;
        var cur = 0;
        links.forEach(function (l, i) {
          if (l.el.getBoundingClientRect().top + window.scrollY <= y) cur = i;
        });
        links.forEach(function (l, i) {
          l.a.classList.toggle('is-active', i === cur);
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 2. Filtres de la galerie ---------- */
  function initFilters() {
    var wrap = document.querySelector('[data-slm-filters]');
    var grid = document.querySelector('[data-slm-grid]');
    if (!wrap || !grid) return;
    var figs = grid.querySelectorAll('figure');

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-filter]');
      if (!btn) return;
      wrap.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var f = btn.dataset.filter;
      Array.prototype.forEach.call(figs, function (fg) {
        fg.style.display = (f === 'all' || fg.dataset.cat === f) ? '' : 'none';
      });
    });
  }

  /* ---------- 3. Lightbox ---------- */
  function initLightbox() {
    var grid = document.querySelector('[data-slm-grid]');
    var lb = document.querySelector('[data-slm-lightbox]');
    if (!grid || !lb) return;

    var imgs = Array.prototype.slice.call(grid.querySelectorAll('img'));
    var lbImg = lb.querySelector('img');
    var idx = 0;

    function visible() {
      return imgs.filter(function (im) {
        return im.closest('figure').style.display !== 'none';
      });
    }
    function show(n) {
      var list = visible();
      if (!list.length) return;
      idx = (n + list.length) % list.length;
      lbImg.src = list[idx].dataset.full || list[idx].src;
      lbImg.alt = list[idx].alt || '';
      lb.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    grid.addEventListener('click', function (e) {
      var im = e.target.closest('img');
      if (!im) return;
      show(visible().indexOf(im));
    });
    lb.querySelector('[data-slm-close]').addEventListener('click', close);
    lb.querySelector('[data-slm-prev]').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    lb.querySelector('[data-slm-next]').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }

  function init() {
    buildToc();
    initFilters();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
